import { useEffect, useState } from "react";
import "./hocScreen.css";
import CloseSave from "../design/close";
import { FaMinus } from "react-icons/fa";

/*
 - `Comp`: הרכיב שיוצג בתוך `HocScreen`.
 - `setClose`: פונקציה לטיפול בסגירת המסך.
 - `ערך`: מצב או אביזר שקובעים אם יש להציג את המסך או לא.
 - `setValue`: פונקציה לעדכון אבזר `value`, המשמשת בדרך כלל לשליטה בנראות המסך.
 - `head`: מחרוזת שתוצג כטקסט הכותרת של המסך.
 - `CompProps`: אובייקט המכיל אביזרים המועברים לרכיב `Comp`. */
 
function HocScreen({Comp, setClose, value, setValue, head, CompProps}) {
    const [noneScreen, setNoneScreen] = useState(true);
    const [divHeight, setDivHeight] = useState('100%');

    useEffect(() => {
        if (typeof value === 'boolean' && !noneScreen) {
            setNoneScreen(true);
        }
    }, [value])

    useEffect(() => {
        const setDynamicHeight = () => {
          const windowHeight = window.innerHeight;
          const threePercentHeight = windowHeight * 0.03;
    
          if (threePercentHeight > 35) {
            setDivHeight('calc(100% - 3%)');
          } else {
            setDivHeight('calc(100% - 35px)');
          }
        };
    
        setDynamicHeight();
        window.addEventListener('resize', setDynamicHeight);
    
        return () => {
          window.removeEventListener('resize', setDynamicHeight);
        };
      }, []);


    return (
        <div className={"hoc-screen"} style={{'display': noneScreen ? 'block' : 'none', 'height': divHeight}}>
            <div className={"hoc-screen-head"}>
                <p> {head} </p>
                <FaMinus className={"hoc-screen-minus"} onClick={() => {setNoneScreen(false); setValue()}} />
                <CloseSave bc="white" c="black" hc="gray" setClose={setClose} />
            </div>

            <div className={"hoc-screen-comp"}>
                <Comp {...CompProps} />
            </div>
        </div>
    )
}


export default HocScreen;